var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cart)?_c('ui-icon-button',{staticClass:"card-button",attrs:{"color":"black","size":"large","type":"secondary"},on:{"click":_vm.openCart}},[_c('i',{staticClass:"material-icons notranslate"},[_vm._v("shopping_cart")]),(_vm.cart.quantity > 0)?_c('small',[_vm._v(_vm._s(_vm.cart.quantity))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }